import { Sidebar } from "../../shared/components";
import { AuthGuard } from "../../shared/guards/AuthGuard";
import { IntegratorQueuePresentation } from "./components/IntegratorQueuePresentation";

export const IntegratorPage = (): JSX.Element => {
	return (
		<AuthGuard>
			<Sidebar>
				<IntegratorQueuePresentation />
			</Sidebar>
		</AuthGuard>
	);
};
